module.exports = __webpack_public_path__ + "static/media/carousel1bg.db211606.png";